<template>
	<div>
		<profile-preview :model="props.event" flat class="w-full px-16 sm:px-24" :to="$spoferanUrl(`/events/${props.event._key}`)"/>

		<div v-if="props.participations.length" class="border-t">
			<participation-preview v-for="participation in props.participations" :key="`participation-${participation.id}`"
								   :force-mobile-layout="props.forceMobileLayout"
								   :without-interaction="props.withoutInteraction"
								   :without-image="props.withoutImage"
								   :event="props.event" :participation="participation"
								   @show-likes="showLikes(participation)"
								   @show-comments="showComments(participation)"/>
		</div>

		<lazy-participation-interactivity-modals v-if="selectedParticipation" :event="props.event" :participation="selectedParticipation"
												 v-model:likes="showLikesModal" v-model:comments="showCommentsModal"/>
	</div>
</template>

<script setup lang="ts">
import type {EventPreview} from "@spoferan/spoferan-ts-core";
import {ref, nextTick} from "vue";

const props = defineProps<{
	event: EventPreview,
	participations: object[],

	// Whether the bottom content row shall be wrapped even when on desktop devices
	forceMobileLayout?: boolean,

	// Whether the comments and likes sections shall be disabled
	withoutInteraction?: boolean,

	// Whether no participation image shall be displayed
	withoutImage?: boolean,
}>();

const showLikesModal = ref(false);
const showCommentsModal = ref(false);
const selectedParticipation = ref(null);

function showLikes(participation) {
	selectedParticipation.value = participation;

	nextTick(() => {
		showLikesModal.value = true;
	});
}

function showComments(participation) {
	selectedParticipation.value = participation;

	nextTick(() => {
		showCommentsModal.value = true;
	});
}

</script>